export const CART_START_WAIT_DETAIL = "Please don’t close this window.";
export const CART_START_BUSY_TITLE = "We couldn’t start your checkout";

export const cartStartWaitStage = (elapsed) => {
  if (elapsed < 5) {
    return { title: "Holding your tickets..." };
  } else if (elapsed < 10) {
    return { title: "Still working on it — this may take a moment..." };
  } else {
    return { lead: "Hang tight!", title: "Lots of people are checking out right now." };
  }
};

export const sentences = (message) => (
  (String(message).match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [String(message)]).map((sentence) => sentence.trim())
);
